const DEFAULT_FONT = { family: '05 SIMBola', size: '18px' }

export function parseFont(font) {
  console.log(`parseFont: ${font}`)
  if (!font) {
    return { ...DEFAULT_FONT }
  }

  const parts = String(font).split(',')
  let family = parts[0].trim()
  if (!family) {
    return { ...DEFAULT_FONT }
  }

  if (family.toLowerCase() === 'simbola') {
    family = '05 SIMBola'
  }

  const size = parts[1] ? `${parseFloat(parts[1])}pt` : DEFAULT_FONT.size
  return { family, size }
}

export function znakStyle(barva, font) {
  console.log(`znakStyle: ${barva}, ${font}`)
  const { family, size } = parseFont(font)
  return {
    color: barva || '#000',
    fontFamily: `"${family}", "Arial Unicode MS", sans-serif`,
    fontSize: size,
  }
}

export function fontAvatarClass(font) {
  console.log(`fontAvatarClass: ${font}`)
  const { family } = parseFont(font)
  if (family.toLowerCase() === 'simbola') {
    return 'simbola'
  }
  return `font-${family.toLowerCase()}`
}